import { Button } from '@/components/ui/button';
import { FolderPlus, Layers, Upload, ArrowRight } from 'lucide-react';
import { DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';

interface InitialStepProps {
  onBuildScratch: () => void;
  onUseTemplate: () => void;
  onUploadCsv: () => void;
}

export function InitialStep({ onBuildScratch, onUseTemplate, onUploadCsv }: InitialStepProps) {
  return (
    <>
      <DialogHeader>
        <DialogTitle>Create segment</DialogTitle>
        <DialogDescription>Choose the type of segment you want to build</DialogDescription>
      </DialogHeader>
      <div className="space-y-3 py-4">
        <Button
          variant="outline"
          className="w-full justify-between h-auto py-3 px-4 items-center border-border/40 hover:bg-accent/30 hover:border-border/60"
          onClick={onBuildScratch}
        >
          <div className="flex items-center gap-3">
            <FolderPlus className="h-5 w-5 text-muted-foreground" />
            <span className="font-medium text-sm">Build from scratch</span>
          </div>
          <ArrowRight className="h-4 w-4 text-muted-foreground" />
        </Button>
        <Button
          variant="outline"
          className="w-full justify-between h-auto py-3 px-4 items-center border-border/40 hover:bg-accent/30 hover:border-border/60"
          onClick={onUseTemplate}
        >
          <div className="flex items-center gap-3">
            <Layers className="h-5 w-5 text-muted-foreground" />
            <span className="font-medium text-sm">Use Template</span>
          </div>
          <ArrowRight className="h-4 w-4 text-muted-foreground" />
        </Button>
        <Button
          variant="outline"
          className="w-full justify-between h-auto py-3 px-4 items-center border-border/40 hover:bg-accent/30 hover:border-border/60"
          onClick={onUploadCsv}
        >
          <div className="flex items-center gap-3">
            <Upload className="h-5 w-5 text-muted-foreground" />
            <span className="font-medium text-sm">Upload CSV (Static)</span>
          </div>
          <ArrowRight className="h-4 w-4 text-muted-foreground" />
        </Button>
      </div>
    </>
  );
}
